import React from 'react';
import cx from 'classnames';

import Link from '../../../../Link';
import { IsNewBadge } from '~/components/Navbar/isNewBadge';

interface Props {
  displayDropdown: boolean;
  links?: any[];
  desktopLinks?: any[];
}

export function Dropdown({ displayDropdown, links, desktopLinks }: Props) {
  return displayDropdown ? (
    <>
      {desktopLinks && (
        <div
          className={cx(
            'z-[-10] w-11/12 rounded-2xl bg-white px-6 pb-5 pt-6 drop-shadow-[0_4px_24px_rgba(0,0,0,0.08)]',
            {
              'desktop:columns-3': desktopLinks.length > 7,
              'desktop:columns-1': desktopLinks.length <= 7
            }
          )}
          data-testid="desktop-mega-nav-dropdown"
        >
          <ul className="m-0 mr-5 w-full list-none p-0">
            {desktopLinks.map(
              (
                {
                  fields: {
                    title,
                    url,
                    openInNewTab,
                    subcategoryLabel,
                    isNew,
                    isNewLabel
                  }
                },
                index
              ) => {
                const displayDuplicateLabel =
                  desktopLinks[index - 1]?.fields?.subcategoryLabel !==
                  subcategoryLabel
                    ? subcategoryLabel
                    : null;
                return (
                  <li
                    key={title}
                    className={cx('pb-2', {
                      'pt-3':
                        displayDuplicateLabel &&
                        index != 0 &&
                        desktopLinks.length <= 7
                    })}
                  >
                    {displayDuplicateLabel && (
                      <p
                        className="typography-title-4 leading-[22px] desktop:pb-2"
                        data-testid="subcategorylabel"
                      >
                        {displayDuplicateLabel}
                      </p>
                    )}
                    {url !== '#' ? (
                      <div
                        className={cx({
                          '!mb-0 flex items-baseline gap-1 ': isNew
                        })}
                      >
                        <Link
                          data-testid="nav-dropdown-sublink"
                          href={url}
                          target={openInNewTab ? '_blank' : '_self'}
                          className="desktop:border-transparent !mb-0 !mr-0 mt-0 w-fit !cursor-pointer whitespace-nowrap text-[14px] font-normal text-[#1d252c] no-underline hover:border-b-[1px] hover:border-[#80D6B0] hover:text-[#035C67] focus:border-b-[1px] focus:border-b-[#80D6B0] desktop:m-0 desktop:mb-4 desktop:mr-[50px] desktop:text-[14px] desktop:font-normal desktop:leading-6 focus:desktop:text-primary"
                          style={{ cursor: 'pointer' }}
                        >
                          {title}
                        </Link>
                        <IsNewBadge isNew={isNew} isNewLabel={isNewLabel} />
                      </div>
                    ) : (
                      <div className="desktop:border-transparent !mb-0 !mr-0 mt-0 w-fit whitespace-nowrap text-[14px] font-normal text-[#1d252c] no-underline desktop:m-0 desktop:mb-4 desktop:mr-[50px] desktop:text-[14px] desktop:font-normal desktop:leading-6">
                        <span className="invisible">{title}</span>
                      </div>
                    )}
                  </li>
                );
              }
            )}
          </ul>
        </div>
      )}
      {/** TODO: Double check if this links conditional is still needed due this Dropdown component is just for desktop */}
      {links && (
        <div
          className="relative z-[9999] mt-5 rounded-[18px] bg-white p-8 pb-4 shadow-[0_4px_24px_rgba(0,0,0,0.08)]"
          data-testid="nav-dropdown"
        >
          <ul className="m-0 w-full list-none columns-2 p-0">
            {links.map(({ fields: { title, url, openInNewTab } }: any) => (
              <li key={title} className="mb-6">
                <Link
                  data-testid="nav-dropdown-sublink"
                  href={url}
                  target={openInNewTab ? '_blank' : '_self'}
                  className="desktop:border-transparent mt-0 w-fit !cursor-pointer whitespace-nowrap text-[14px] font-normal text-[#1d252c] no-underline desktop:m-0 desktop:mb-4 desktop:mr-[50px] desktop:border-b desktop:text-[14px] desktop:font-normal desktop:leading-6 hover:desktop:border-b hover:desktop:border-[#1d252c] hover:desktop:text-[#1d252c] focus:desktop:border-b focus:desktop:border-[#1d252c] focus:desktop:text-[#1d252c]"
                  style={{ cursor: 'pointer' }}
                >
                  {title}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      )}
    </>
  ) : null;
}
